var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2531 2L22 2.73505L18.4755 15.8712L15.7286 15.1361L19.2531 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5327 15.8385L18.2796 16.5735L16.8733 18.1573L15.9576 17.9123L15.5327 15.8385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.3333L22 20.3333V22L2 22V20.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 17H14.9167L15.3333 18.6667L2.83333 18.6667L2.83333 17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_1419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribble);
export default __webpack_public_path__ + "static/media/Scribble.bf002a3383111f711d9c532f6c3458c0.svg";
export { ForwardRef as ReactComponent };